import { ApiTags } from '@nestjs/swagger';
import { Controller, Post, Body, Logger, Req } from '@nestjs/common';
import {  InformationMessageError, NoRecordsFound, InternalServerError, ValidationMessageError,  errorHandler} from '@gtpl/shared-utils/error-messages';
import { AdvancedConsoleLogger } from 'typeorm';
import { PinoLogger, InjectPinoLogger } from 'nestjs-pino';
import { request } from 'https';
import { LogsService } from './logs.service';
import { ErrorResponse } from '@gtpl/shared-models/common-models';
// import {LogsDto} from 'libs/shared-models/user-logs/src/lib/Logs/logs.dto';
import{LogsResponseModel} from 'libs/shared-models/user-logs/src/lib/Logs/logs-response.model'
import { LogsDTO } from './dto/logs.dto';

@ApiTags('Logs')
@Controller('logs')
export class LogsController {

  
  constructor(private logsService: LogsService){}
  @Post('/getLogs')
  async getLogs(): Promise<any> {
    try {
      // return await this.logsService.getLogs();
    } catch (error) {
     throw new ErrorResponse(11106,'Logs not retrieved');
    }
  }

  @Post('/createLog')
  async createLog(@Body() logDto:LogsDTO): Promise<any> {
    console.log('Controller')
    console.log('----------')

    try {
      return await this.logsService.createLog(logDto);
    } catch (error) {
     throw new ErrorResponse(11106,'Logs not retrieved');
    }
  }
   
}
